import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import '~/polyfills/array-findlastindex';
import { init, browserTracingIntegration } from '@sentry/remix';

import { startTransition, type ErrorInfo, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { sendAppSignalError } from './lib/appsignal.client';

init({
  dsn: 'https://63c9c85c78964d27b2264b54d8439bd3@o4509445939331072.ingest.us.sentry.io/4509866599710721',
  tracesSampleRate: 1,
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

startTransition(() => {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element missing');
  }

  window.__allowDOMMutations?.();

  hydrateRoot(rootElement, <RemixBrowser />, { onRecoverableError });
});

function onRecoverableError(capturedError: unknown, errorInfo: ErrorInfo) {
  const error = capturedError instanceof Error ? capturedError : new Error(String(capturedError));

  const errorWithComponentStack = new Error(`${error.message}\nComponent stack: ${errorInfo.componentStack}`, {
    cause: error.cause,
  });

  errorWithComponentStack.stack = error.stack;
  errorWithComponentStack.name = 'BoltRenderRecoverableError';

  sendAppSignalError(errorWithComponentStack);
}
